import {Component} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {environment} from '../../environments/environment';
import {fixturesAllowed} from './fixtures-environment';
import {FixturesModalComponent} from './fixtures-modal.component';

@Component({
  selector: 'app-fixtures-button',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, MatTooltipModule],
  template: `@if (enabled) {
    <button mat-icon-button color="primary" type="button" (click)="open()" matTooltip="Testovací data (fixtures)" aria-label="Vytvořit testovací data">
      <mat-icon>science</mat-icon>
    </button>
  }`,
})
export class FixturesButtonComponent {
  readonly enabled = fixturesAllowed(environment);

  constructor(private dialog: MatDialog) {}

  open(): void {
    if (!this.enabled || this.dialog.getDialogById('fixtures-modal')) return;
    this.dialog.open(FixturesModalComponent, {id: 'fixtures-modal', width: '860px', maxWidth: '96vw', maxHeight: '95vh'});
  }
}
